var React = require('react');

function Image (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M76 12H20C15.5817 12 12 15.5817 12 20V76C12 80.4183 15.5817 84 20 84H76C80.4183 84 84 80.4183 84 76V20C84 15.5817 80.4183 12 76 12Z","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M36 44C40.4183 44 44 40.4183 44 36C44 31.5817 40.4183 28 36 28C31.5817 28 28 31.5817 28 36C28 40.4183 31.5817 44 36 44Z","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M84 59.9998L71.656 47.6558C70.1558 46.156 68.1213 45.3135 66 45.3135C63.8787 45.3135 61.8442 46.156 60.344 47.6558L24 83.9998","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Image.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = Image;

Image.default = Image;
